import { TriangleAlert } from 'lucide-react';
import { format } from '@/i18n/format';
import { t } from '@/i18n/t';

/** Hinweis auf eine Lücke in den Daten („Achtung: Daten seit 3. Okt. 2026 unvollständig.“). */
export function DataGapNotice({ since }: { since: string }) {
  return (
    <p className="flex items-start gap-2 rounded-control border border-line bg-surface-sunken px-3 py-2 text-body text-warn">
      <TriangleAlert aria-hidden="true" className="mt-0.5 size-5 shrink-0" />
      <span>{t('states.dataGap', { date: format.date(since) })}</span>
    </p>
  );
}
